import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

export const useDeleteJobMutation = () => {
  return useMutation({
    mutationFn: async (jobId: string) => {
      await fetchClient.DELETE(endpoints.job, {
        params: { path: { id: jobId } },
      });
    },
    onSettled: () => {
      invalidateQuery(jobsQueryKeys.lists())();
    },
  });
};
